import { BaseTransactionModel } from '@shared/app/scripts/classes/base-transaction-model';
import { SaleModel } from './sale-model';
import { merge } from 'lodash';

/**
 * The transit order model
 */
export class TransitTransitModel {
  dir: string;
  transitPeer: string;
  transitWarehouse: string;
}

/**
 * The transit order model
 */
export class TransitModel extends BaseTransactionModel {
  transit: TransitTransitModel;

  constructor(originalValue?: Partial<SaleModel>) {
    super();
    merge(this, originalValue);
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const TransitModelProvider = {
  provide: 'TransitModel',
  useValue: TransitModel,
};
